<template>
	<MobileLayout>
		<template #header>
			<MobileMenu :menus="getMenus" @change="changeMenu" />
		</template>
		<template #content>
			<CoreCacheRouter />
		</template>
		<template #floating>
			<SmartLayoutC compId="layout_floating" mode="basic-mobile" key="layout_floating" />
		</template>
	</MobileLayout>
</template>

<script setup>
import { computed, inject } from 'vue';
import MobileMenu from '@/views/layout/components/mobileMenu';
import { useNavigation } from '@rebuild/hooks/useNavigation';
import MobileLayout from '@rebuild/materials/shared/layout_wrapper/MobileLayout.vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import CoreCacheRouter from '@rebuild/materials/shared/layout_wrapper/CoreCacheRouter.vue';

const templateMenus = inject('TEMPLATE_MENUS');
const getMenus = computed(() => templateMenus?.value || []);

const { viewMenuInFlowX } = useNavigation();
const changeMenu = menuInfo => {
	return viewMenuInFlowX(menuInfo.item);
};
</script>

<style lang="less" scoped></style>
